<app-form-section title="Teléfonos" icon="call" iconColor="blue">
  <div class="table-container">
    <table mat-table [dataSource]="phones" class="w-full">
      <!-- Tipo -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let phone">{{ phone.type?.type }}</td>
      </ng-container>

      <!-- Número -->
      <ng-container matColumnDef="prefix">
        <th mat-header-cell *matHeaderCellDef>Número Telefónico</th>
        <td mat-cell *matCellDef="let phone">{{ phone.prefix }} {{ phone.phone }}</td>
      </ng-container>

      <!-- Estado -->
      <ng-container matColumnDef="statusId">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
        <td mat-cell *matCellDef="let phone" class="px-6 text-left">
          <mat-slide-toggle [checked]="phone.statusId === 1" (change)="onStatusToggle($event.checked, phone)"
            color="primary">
          </mat-slide-toggle>
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <button color="primary" mat-button (click)="openPhoneModal()" matTooltip="Agregar Teléfono">
            <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
          </button>
        </th>
        <td mat-cell *matCellDef="let phone">
          <div class="button-container flex gap-2">
            <button mat-icon-button (click)="openPhoneModal(phone)" matTooltip="Editar Registro">
              <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
            </button>
            <button mat-icon-button (click)="openDeletePhone(phone)" matTooltip="Eliminar Registro">
              <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsPhone"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsPhone"></tr>
    </table>
  </div>
</app-form-section>